export default "__VITE_ASSET__D$vF18RL__"